import './index.scss'
import Swiper from 'swiper';
import { Pagination, Navigation, Controller, EffectFade, Parallax } from 'swiper/modules'; // import Swiper modules (if needed). Full list here: https://swiperjs.com/swiper-api#modules

import { toggleSwiperLock } from './../../js/toggleSwiperLock'

class CrossNav {
    constructor(el) {
        this.$el = el
        // console.log('CrossNav::constructor')
        
    }
    init() {
        const slides = this.$el.querySelectorAll('.chapters__slide');
        this.swiper = new Swiper(this.$el.querySelector('.chapters__swiper'), {
            modules: [Pagination, Navigation, Controller, EffectFade, Parallax],
            speed: 1000,
            effect: 'fade',
            parallax: true,
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: '.chapters__pagination__wrapper',
                type: 'bullets',
                bulletElement: 'div',
                clickable: true,
                renderBullet: function (index, className) {
                    let title = slides[index].querySelector('.chapters__title').innerText
                    return `<div class="${className} chapters__pagination__slide swiper-slide korolev--s">${title}</div>`
                },
            },
        })
        
        this.swiperNav = new Swiper(this.$el.querySelector('.chapters__pagination'), {
            speed: 1000,
            slidesPerView: 'auto',
            watchOverflow: true,
            centeredSlides: true,
            spaceBetween: 20,
            on: {
                init: function( swiper ) {
                  return toggleSwiperLock(swiper)
                },
                click: function (swiper) {
                    swiper.slideTo(this.clickedIndex, 1000)  
                },
                resize: function( swiper ) {
                  return toggleSwiperLock(swiper)
                },
            },
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-tts-crossnav') ].forEach($block => {
        $block.expandygg = new CrossNav($block)
    })
}, {capture: false, passive: true, once: true} || false)